module.exports = __webpack_public_path__ + "static/media/notes-icon.699f8f8a.svg";